module.exports = __webpack_public_path__ + "static/sakés-1b48af8ff30a6300e633a562bd993a63.jpg";